import { getDirection, setService, getService } from '../store/line-store.js'

import { lineSelected } from '../utils/dom-utils.js'

export class ServiceButtonElement extends HTMLElement {
	constructor(name = '') {
		super()

		this.button = document.createElement('button')
		this.button.textContent = 'Service'
		this.appendChild(this.button)

		this.setName(name)

		this.button.addEventListener('click', () => {
			this.onclick()
		})
	}

	setName(name) {
		this.name = name
		this.button.textContent = name
		if (name === getService()) {
			this.button.classList.add('button-active')
		}
	}
	onclick() {
		setService(this.name)
		lineSelected()
	}
}

customElements.define('service-button', ServiceButtonElement)
